import { onExternalCalendarActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { ExternalCalendarActivityCard } from "./ExternalCalendarActivityCard";
import { useCurrentUser } from "common/SessionContext";

interface Props {
  externalCalendarId: number
  config: server.dto.ActivityPanelConfig
}

export const ExternalCalendarActivityPanel = (props: Props) => {
  const currentUser = useCurrentUser();
  return <ActivityPanel<server.dto.ExternalCalendarActivity>
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.ExternalCalendar.ListActivity({ itemId: props.externalCalendarId, page, perPage })}
    renderActivity={(activity => <ExternalCalendarActivityCard
      key={activity.activityId}
      activity={activity}
    />)}
    onActivityRegisterFn={onExternalCalendarActivity}
    onActivity={(activity) => {
      if (activity.itemId !== props.externalCalendarId) return { refreshActivities: false };

      const iAmActor = (activity.actor?.userId === currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}